import { render, staticRenderFns } from "./PartnerHasPartnerBankingIdsTable.vue?vue&type=template&id=bdf8ab30&"
import script from "./PartnerHasPartnerBankingIdsTable.vue?vue&type=script&lang=ts&"
export * from "./PartnerHasPartnerBankingIdsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VIcon,VSpacer,VTextField})
